@if (iconHtml | async) {
    <span
        [innerHTML]="iconHtml | async | sanitize: securityContext"
        class="[&>svg]:flex [&>svg]:grow [&>svg]:w-full [&>svg]:h-auto"></span>
}
